import layoutView from "./layoutView";
export default {
  mixins: [layoutView],
  data() {
    return {
      // watchOpenerClosedTimer: null,
      isWindowOpener: false
    };
  },
  created() {
    try {
      if (this.$multiView) {
        this.$dialogArgs = this.$multiView.dialogArgs ? JSON.parse(this.$multiView.dialogArgs) : null;
        this.$openerVm = this.$multiView.openerVm;
      }
      // 判断弹出层,优先级 iframe 》dialog 》window
      else if (window?.frameElement?.closest('.el-dialog[role="dialog"]')) {
        //兼容DsfIframe组件 或者DsfIframeDialog组件
        let dialog = window?.frameElement?.$dialog || window?.frameElement?.args?.$dialog;
        if (dialog) {
          let args = window?.frameElement?.args || window?.frameElement?.$dialog?.dialogArgs || null;
          if (dsf.type(args) == "string") {
            args = JSON.parse(args);
          }
          this.$dialogArgs = window.frameElement.args ? JSON.parse(window.frameElement.args) : null;
          this.$openerVm = dialog.openerVm;
        }
      } else if (this.$dialog) {
        this.$dialogArgs = this.$dialog.dialogArgs || null;
        this.$openerVm = this.$dialog.openerVm;
      } else if (window.opener) {
        this.isWindowOpener = true;
        if (window.opener.dialogArgs && window.opener.dialogArgs[window.name]) {
          this.$dialogArgs = JSON.parse(window.opener.dialogArgs[window.name]) || null;
        }
        if (window.opener.openerVms && window.opener.openerVms[window.name]) {
          this.$openerVm = window.opener.openerVms[window.name] || null;
        }
      }
      // 兼容 新开页面并且跨域的问题。清空opner
      // try {
      //   if(this.$openerVm)this.$openerVm.location.href
      // } catch (error) {
      //   console.error(error)
      //   this.$openerVm = null
      // }
      if (this.$openerVm && this.$openerVm._isVue) {
        //监听父窗口是否被销毁
        this.$openerVm.$on("hook:destroyed", this.$clearOpenerVm);
      }
    } catch (ex) {
      dsf.error(ex);
    }
  },
  beforeDestroy() {
    this.$clearOpenerVm();
    // this.watchOpenerClosedTimer && clearInterval(this.watchOpenerClosedTimer);
  },
  methods: {
    $openerClosed() {
      this.$clearOpenerVm();
    },
    $clearOpenerVm() {
      this.$openerVm && this.$openerVm.$off("hook:destroyed", this.$clearOpenerVm);
      this.$openerVm = null;
    },
    $closeWindow() {
      if (dsf.isMultiPage()) {
        let view = this.$el.closest(".dsf-multiPage-home-view");
        if (view) {
          let viewControl = view.__vue__;
          viewControl?.close?.();
          return;
        }
        this.$multiView;
      }
      dsf.layer.closeWindow(window, this);
    },
    reloadParentViewData() {
      //pc端获取当前页面的父页面并刷新父页面数据
      if (this.$openerVm) {
        //更新父页面数据
        this.$openerVm && this.$openerVm.reloadData && this.$openerVm.reloadData();
      }
    }
  }
};
